import { ResponseHelper } from '../_helpers/response.helper'
import axiosInstance from './axios.service'

export class HeatersService {
  private setError: (message: string | null) => void

  constructor (setError: (message: string | null) => void) {
    this.setError = setError
  }

  async getCurrentHeaters () {
    return axiosInstance
      .get('/heaters/current')
      .then(res => res.data.data)
      .catch(e => ResponseHelper.handleError(e, this.setError))
  }
}
